import React, { useContext } from 'react';
import { ErpContext } from '../../context/ErpContext.js';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { styled } from '@mui/material/styles';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiBackdrop-root': {
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
    backdropFilter: 'blur(8px)',
  },
  '& .MuiDialog-paper': {
    borderRadius: '16px',
    padding: theme.spacing(3),
    minWidth: '400px',
    maxWidth: '500px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
  },
}));

const SessionExpiredModal = () => {
  const { isSessionExpired, logout } = useContext(ErpContext);

  const handleLogout = () => {
    logout();
  };

  return (
    <StyledDialog
      open={isSessionExpired}
      disableEscapeKeyDown
      aria-labelledby="session-expired-dialog-title"
      aria-describedby="session-expired-dialog-description"
    >
      <DialogTitle id="session-expired-dialog-title">
        <Box display="flex" alignItems="center" gap={2}>
          <LockOutlinedIcon 
            sx={{ 
              fontSize: 40, 
              color: 'error.main' 
            }} 
          />
          <Typography variant="h5" component="span" fontWeight="bold">
            Sesión Expirada
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <Typography 
          variant="body1" 
          id="session-expired-dialog-description"
          sx={{ mt: 2, mb: 2 }}
        >
          Tu sesión ha expirado por seguridad (24 horas de inactividad).
        </Typography>
        <Typography 
          variant="body2" 
          color="text.secondary"
        >
          Por favor, vuelve a iniciar sesión para continuar usando el sistema.
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        <Button
          onClick={handleLogout}
          variant="contained"
          color="primary"
          size="large"
          fullWidth
          sx={{
            py: 1.5,
            fontSize: '1rem',
            fontWeight: 'bold',
          }}
        >
          Cerrar Sesión
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default SessionExpiredModal;

